import { HttpRequest, HttpHandlerFn, HttpEvent, HttpStatusCode } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { NotificationService } from '@ui/aos-lib';
import { isInvalidGrantError } from './request-error-handler.interceptor';

const NUMBER_OF_MODALS = 5;
const ERROR_TEXT = 'If the issue persists, please contact Customer Support with the following Trace ID:';

export function errorNotificationInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const notification = inject(NotificationService);
  const xTraceresponse = 'x-traceresponse';
  const listOfException = [HttpStatusCode.Conflict];

  return next(request).pipe(
    catchError(err => {
      if (listOfException.includes(err.status) || isInvalidGrantError(request.url, err.error)) {
        return throwError(() => err);
      }
      const notificationWrapper = document.querySelector('.k-notification-group');
      const quantityOfModals = notificationWrapper ? notificationWrapper?.children?.length : 0;
      const traceId = err.headers.has(xTraceresponse) ? err.headers.get(xTraceresponse).split('-')[1] : '';
      const getMessage = (status: HttpStatusCode): string => {
        if (!traceId) {
          return 'An error has occurred.';
        }
        switch (status) {
          case HttpStatusCode.Unauthorized:
          case HttpStatusCode.Forbidden:
            return 'Sorry, you are not authorized to view this page or complete this action.';
          case HttpStatusCode.BadRequest:
          case HttpStatusCode.NotFound:
            return `Sorry, this content was not found. Please check the link is valid. ${ERROR_TEXT} ${traceId}`;
          case HttpStatusCode.RequestTimeout:
          case HttpStatusCode.InternalServerError:
          case HttpStatusCode.BadGateway:
          case HttpStatusCode.ServiceUnavailable:
          case HttpStatusCode.GatewayTimeout:
            return `Server took too long to respond. Please try again in a few minutes. ${ERROR_TEXT} ${traceId}`;
          default:
            return `An error has occurred. Please refresh the browser and try again. ${ERROR_TEXT} ${traceId}`;
        }
      };

      if (quantityOfModals < NUMBER_OF_MODALS) {
        notification.show(getMessage(err.status));
      }

      return throwError(() => err);
    })
  );
}
